import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-scroll'
// import { Link } from 'react-router-dom'
import './Navbar.scss'
// import $ from 'jquery'


function Navbar() {

    const [click, setClick] = useState(false)
    const [button, setButton] = useState(true)

    const handleClick = () => setClick(!click)

    const closeMobileMenu = (e) => {
        setClick(false)
    }

    const showButton = () => {
        if (window.innerWidth <= 960) {
            setButton(false)
        } else {
            setButton(true)
        }
    }


    useEffect(() => {
        showButton()
    }, [])

    window.addEventListener('resize', showButton)
    return (
        <>
            <nav className="navbar">
                <div className="navbar-container">
                    <Link to="heroe" className="navbar-logo" onClick={closeMobileMenu} activeClass="active" spy={true} smooth={true} offset={-50} duration={500} >
                        <img className="softmax-logo" src="/images/softmax-white.png" alt="" />
                    </Link>
                    <div className="menu-icon" onClick={handleClick}>
                        <i className={click ? "fa-solid fa-times fa-2x main-color" : "fa-solid fa-bars fa-2x main-color"} />
                    </div>
                    <ul className={click ? "nav-menu active" : "nav-menu"}>
                        <li className="nav-item">
                            <Link to="heroe" id="heroe-nav-item" className="nav-links" onClick={closeMobileMenu} activeClass="active" spy={true} smooth={true} offset={-50} duration={500} >
                                Home
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="services" id="services-nav-item" className="nav-links" activeClass="active" spy={true} smooth={true} offset={-50} duration={500} onClick={closeMobileMenu}>
                                Services
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="technologies" className="nav-links" onClick={closeMobileMenu} activeClass="active" spy={true} smooth={true} offset={-50} duration={500} >
                                Technologies
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="contact-us" className="nav-links" onClick={closeMobileMenu} activeClass="active" spy={true} smooth={true} offset={-50} duration={500} >
                                Contact us
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="subscribe" className="nav-links" onClick={closeMobileMenu} activeClass="active" spy={true} smooth={true} offset={-50} duration={500} >
                                Subscribe
                            </Link>
                        </li>
                    </ul>
                </div>

            </nav>
        </>
    )
}

export default Navbar